// Bascule de thème : préférence système par défaut, choix explicite mémorisé sur
// l'appareil. Le script inline de public/index.html applique déjà data-theme avant
// le premier rendu pour éviter le flash de thème clair ; ce module lit/écrit le
// même stockage pour que React reste synchronisé avec ce choix.
const STORAGE_KEY = "rise-t-theme";

export const getStoredThemeMode = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === "light" || stored === "dark" ? stored : null;
  } catch {
    return null;
  }
};

export const getSystemThemeMode = () =>
  window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";

export const getEffectiveThemeMode = () => getStoredThemeMode() ?? getSystemThemeMode();

export const applyThemeMode = (mode) => {
  document.documentElement.setAttribute("data-theme", mode);
};

export const persistThemeMode = (mode) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Stockage indisponible (navigation privée) : le choix ne survit pas au rechargement,
    // ce n'est pas bloquant pour la session en cours.
  }
};
